import { Pool } from "../../utils/Pool";
const className = "AlphaCmd";
export class AlphaCmd {
    static create(alpha) {
        var cmd = Pool.getItemByClass(className, AlphaCmd);
        cmd.alpha = alpha;
        return cmd;
    }
    recover() {
        Pool.recover(className, this);
    }
    run(runner, gx, gy) {
        runner.alpha(this.alpha);
    }
    getBounds(assembler) {
    }
    get cmdID() {
        return AlphaCmd.ID;
    }
}
AlphaCmd.ID = className;
